
jQuery(function() {
  $('.swatch').each(function(){   
 $swatch_index = $(this).data('option-index')+1; 
    $current_index = $(".selector-wrapper:nth-of-type("+$swatch_index+")").find('option:selected').index();
    $(this).find('.swatch_element_container .swatch-element_radio_box input[data-swatch-index="' + $current_index + '"]').prop('checked', true);
 });
   function swatch($index) {
        $select = $("#SingleOptionSelector-0"); // $('.single-option-selector')
        $select.find("option").eq($index).prop('selected', true);
        $select.trigger('change', ['select_trigger']);

        $('.swatch .swatch_element_container .swatch-element_radio_box input[data-swatch-index="' + $index + '"]').prop('checked', true);//.swatch .swatch_element_container.Color .swatch-element_radio_box input[data-swatch-index="'+$index+'"]
        $('.swatch .swatch_element_container .swatch-element_radio_box input[data-swatch-index="' + $index + '"]').trigger('change');
    }
  
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    youPrice();
    youvariant()
  });
  
 function youPrice() {
	var old_price = $('.product-price-item--regular').text().replace('£', '');

    var new_price = $('.product-price-item--sale').text().replace('£', '');

   	var old_prices =  parseInt(old_price);
    var save = old_price - new_price;
   	save = save.toFixed(2);
    var percent=Math.round(save/old_price*100);
    $('#percentSavings').html(percent);

    $('#compareSavings').html('(£'+save+')');
   
 }   
  var handleizeStr = function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
}; 
 
 function youvariant() {
       var productData = $(".product-json").text();
    var productJSON = JSON.parse( productData );
    var productVariantObj = productJSON.variants;
 for (var i=0,length=productJSON.variants.length; i<length; i++) {
        var productVariants = productJSON.variants[i];
        
        if(productVariants.available){
          for (var j=0,optlength=productVariants.options.length; j<optlength; j++) {
            var variantOption = productVariants.options[j];
                variantOption = handleizeStr(variantOption);
            $('.swatch[data-option-index="'+j+'"] .'+variantOption+'').removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
          }
          
        }
      }
 }
  /*   countdown timer */

var hoursleft = 2;
var minutesleft = 28; //give minutes you wish
var secondsleft = 30; // give seconds you wish
var finishedtext = "This Sale Has Ended!";
var end1;

starttimer();

function starttimer(){
    if(localStorage.getItem("end1")) {
        end1 = new Date(localStorage.getItem("end1"));
    } else {
        end1 = new Date();
        end1.setHours(end1.getHours()+hoursleft);
        end1.setMinutes(end1.getMinutes()+minutesleft);
        end1.setSeconds(end1.getSeconds()+secondsleft);

    }
    var counter = function () {
        var now = new Date();
        var diff = end1 - now;

        diff = new Date(diff);


        var sec = parseInt((diff/1000)%60);
        var mins = parseInt((diff/(1000*60))%60);
        var hours = parseInt((diff/(1000*60*60))%24);

        if (hours < 24) {
            hours = "0" + hours;
        }
        if (mins < 10) {
            mins = "0" + mins;
        }
        if (sec < 10) {
            sec = "0" + sec;
        }
        if (now >= end1) {
            clearTimeout(interval);
            // localStorage.setItem("end", null);
            localStorage.removeItem("end1");
            localStorage.clear();
            // document.getElementById('divCounter').innerHTML = finishedtext;
            starttimer();
        }
        else {
            var value = hours + "<span class='smalltext'>Hours </span>" + "<span class='spcdt'>:</span>" + mins + "<span class='smalltext'>Min</span>" + "<span class='spcdt'>:</span>" + sec + "<span class='smalltext'>Sec</span>";
            localStorage.setItem("end1", end1);
            if(document.getElementById('divCounter')){
            document.getElementById('divCounter').innerHTML = value;
            }
        }
    };
    var interval = setInterval(counter, 1000);
}

/* new countdown timer */
  
});

